(function () {
  function initUmtGlobalPromoBarSafeV1() {
    var bar = document.getElementById('umtGlobalPromoBarSafeV1');

    if (!bar) return;
    if (bar.getAttribute('data-umt-global-promo-ready') === 'true') return;

    bar.setAttribute('data-umt-global-promo-ready', 'true');

    var closeButton = bar.querySelector('[data-umt-global-promo-close]');
    var storageKey = 'umt_global_promo_bar_safe_v1_closed';

    var isThemeEditor = false;

    try {
      isThemeEditor = !!(window.Shopify && Shopify.designMode);
    } catch (error) {
      isThemeEditor = false;
    }

    /*
      Theme Editor içinde localStorage ile bandı kalıcı gizlemiyoruz.
      Böylece düzenleme ekranında yanlışlıkla kapatınca bant kaybolup test zorlaşmaz.
    */
    if (!isThemeEditor) {
      try {
        if (localStorage.getItem(storageKey) === '1') {
          bar.classList.add('umtGlobalPromoBarSafeV1--hidden');
          return;
        }
      } catch (error) {}
    }

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        bar.classList.add('umtGlobalPromoBarSafeV1--hidden');

        if (!isThemeEditor) {
          try {
            localStorage.setItem(storageKey, '1');
          } catch (error) {}
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUmtGlobalPromoBarSafeV1);
  } else {
    initUmtGlobalPromoBarSafeV1();
  }

  document.addEventListener('shopify:section:load', initUmtGlobalPromoBarSafeV1);
})();